export default __webpack_public_path__ + "fe2176f79edaa716e6212cca53949439.woff2";